import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function DataAnalytics() {
  return (
    <>
      <Breadcrumb title="Data Analytics" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/data.png"
                      alt="Data Analytics Services"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We turn complex healthcare and business data into actionable
                    insights through robust data warehousing and visualization
                    solutions. Our analytics platforms support smarter decisions
                    and real-time performance tracking.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Centralized data warehousing solutions</li>
                    <li>Interactive dashboards and reporting</li>
                    <li>Predictive analytics and trend analysis</li>
                    <li>AI/ML-enabled data insights</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Faster, data-driven decision-making</li>
                    <li>Improved operational visibility</li>
                    <li>Actionable insights for growth and efficiency</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Service Blocks */}
          <div className="row">
            <ServiceBlock
              title="Data Warehousing"
              items={[
                "Data warehouse architecture & design",
                "ETL / ELT pipeline development",
                "Cloud data warehouses (Redshift, BigQuery, Snowflake, Azure Synapse)",
                "Data lake creation & management",
                "Multi-source data integration",
                "Data quality & governance",
                "Real-time ingestion & streaming",
                "Security & compliance implementation",
              ]}
            />

            <ServiceBlock
              title="Business Intelligence & Visualization"
              items={[
                "BI dashboards (Power BI, Tableau, Looker, Qlik)",
                "Interactive reports",
                "Executive KPI dashboards",
                "Sales, marketing & finance dashboards",
                "Self-service BI",
                "Automated reporting",
                "Data storytelling & insights",
              ]}
            />

            <ServiceBlock
              title="Statistical & Predictive Modeling"
              items={[
                "Sales forecasting",
                "Demand planning",
                "Customer churn prediction",
                "Lead scoring & conversion analysis",
                "Risk modeling",
                "Inventory optimization",
                "Pricing optimization",
              ]}
            />

            <ServiceBlock
              title="Data Mining & Pattern Detection"
              items={[
                "Trend & seasonality analysis",
                "Customer segmentation",
                "Anomaly & fraud detection",
                "Behavioral pattern analysis",
              ]}
            />

            <ServiceBlock
              title="Advanced Predictive Services"
              items={[
                "Time-series forecasting",
                "Propensity modeling",
                "Predictive maintenance",
                "Sentiment prediction",
              ]}
            />

            <ServiceBlock
              title="AI Product Development"
              items={[
                "Custom ML models",
                "End-to-end AI pipelines",
                "NLP solutions",
                "Computer vision systems",
                "Voice AI & chatbots",
                "Recommendation engines",
              ]}
            />

            <ServiceBlock
              title="Machine Learning Services"
              items={[
                "Model training & optimization",
                "Feature engineering",
                "MLOps (CI/CD for ML)",
                "Model monitoring & retraining",
              ]}
            />

            <ServiceBlock
              title="Automation & Intelligence"
              items={[
                "AI-powered RPA",
                "Workflow automation",
                "Predictive decision engines",
                "AI personalization systems",
              ]}
            />

            <ServiceBlock
              title="AI for Business Use Cases"
              items={[
                "AI customer support",
                "Marketing intelligence & lead scoring",
                "Healthcare & HealthTech AI",
                "Finance AI (fraud, risk)",
                "Supply chain optimization",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Service Block */
function ServiceBlock({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
